/* eslint-disable import/prefer-default-export */
export const DAYS_OF_WEEK = {
  monday: {
    id: 1,
    code: 'M',
  },
  tuesday: {
    id: 2,
    code: 'Tu',
  },
  wednesday: {
    id: 3,
    code: 'W',
  },
  thursday: {
    id: 4,
    code: 'Th',
  },
  friday: {
    id: 5,
    code: 'F',
  },
  saturday: {
    id: 6,
    code: 'Sa',
  },
  sunday: {
    id: 7,
    code: 'Su',
  },
};
